import React from "react";
import PropTypes from "prop-types";
import styles from "./AccountsTableComponent.module.css";

function fmtAmount(n, currencyCode) {
  const num = typeof n === "number" ? n : parseFloat(n);
  if (Number.isNaN(num)) return "—";
  try {
    return new Intl.NumberFormat(undefined, {
      style: currencyCode ? "currency" : "decimal",
      currency: currencyCode || undefined,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return num.toFixed(2);
  }
}

function amountClass(n) {
  const num = typeof n === "number" ? n : parseFloat(n);
  if (Number.isNaN(num)) return "";
  if (num > 0) return "amount positive";
  if (num < 0) return "amount negative";
  return "";
}

export default function AccountsTableComponent({ items, onAdd, onEdit }) {
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <div className={`pp-table is-cozy ${styles.wrap}`}>
      {/* toolbar */}
      <div className={`d-flex justify-content-end align-items-center gap-2 p-3 ${styles.toolbar}`}>
        <button className="btn btn-primary btn-sm btn-compact" onClick={onAdd}>Add Account</button>
      </div>

      {/* empty state */}
      {!hasItems && (
        <div className="pp-table-empty">
          <div>No accounts yet.</div>
          <button className="btn btn-compact btn-primary mt-1" onClick={onAdd}>
            Add your first account
          </button>
        </div>
      )}

      {/* table */}
      {hasItems && (
        <div className="pp-table-scroll">
          <table className="table table-striped table-hover align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" data-col="lg" className="truncate">Name</th>
                <th scope="col" data-col="sm">Currency</th>
                <th scope="col" data-col="md" className="truncate">Type</th>
                <th scope="col" className="is-num is-mono">Balance</th>
                <th scope="col" data-col="xs"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((acc, index) => {
                const bal = acc.accountBalance ?? acc.balance ?? 0;
                return (
                  <tr key={index}>
                    <td className="truncate">{acc.name || "—"}</td>
                    <td>{acc.currencyCode || "—"}</td>
                    <td className="truncate">{acc.systemTypeName || acc.systemTypeId || "—"}</td>
                    <td className={`is-num is-mono ${amountClass(bal)}`}>
                      {fmtAmount(bal, acc.currencyCode)}
                    </td>
                    <td className="text-nowrap">
                      <div className="row-actions">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => onEdit(acc)}
                        >
                          Edit
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

AccountsTableComponent.propTypes = {
  items: PropTypes.array,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
};
